import { SelectAllBulkEventType } from './select-all-bulk-event-type';

export class SelectAllBulkEvent<TData> {
  handled = false;

  constructor(
    readonly id: string,
    readonly type: SelectAllBulkEventType,
    readonly data: TData
  ) {}
}
